import useSWR from "swr";

import salesDashboardService from "@/services/sales-dashboard.service";

export interface UseGetTotalOrderAmountProps {
  startDate: string;
  endDate: string;
}

export type UseGetTotalOrderAmountReturn = {
  data: {
    currentPeriodTotalOrderAmount: number;
    previousPeriodTotalOrderAmount: number;
    percentageIncrease: number;
  } | null;
  isLoading: boolean;
  error: Error | null;
};

const useGetTotalOrderAmount = ({
  startDate,
  endDate,
}: UseGetTotalOrderAmountProps): UseGetTotalOrderAmountReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR(
    ["getTotalOrderAmount", startDate, endDate],
    () => salesDashboardService.totalOrderAmount(startDate, endDate),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetTotalOrderAmount;
